import { Link } from 'react-router-dom';
import { getFeaturedArticles } from '@/mocks/articles';

export default function FeaturedArticles() {
  const featuredArticles = getFeaturedArticles();

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-12 gap-4">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              精选文章
            </h2>
            <p className="text-foreground-600 text-sm">
              由权威专家团队精心撰写的优质内容
            </p>
          </div>
          <Link
            to="/category/puberty"
            className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 transition-colors duration-200 whitespace-nowrap"
          >
            浏览全部文章
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {featuredArticles.map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className={`group bg-background-50 rounded-xl overflow-hidden transition-all duration-300 hover:scale-[1.01] ${
                index === 0 ? 'md:col-span-2 md:flex' : ''
              }`}
            >
              <div
                className={`overflow-hidden ${
                  index === 0
                    ? 'md:w-2/5 md:min-h-[240px] min-h-[200px]'
                    : 'min-h-[200px]'
                }`}
              >
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className={`p-5 md:p-6 ${index === 0 ? 'md:w-3/5 md:flex md:flex-col md:justify-center' : ''}`}>
                <div className="flex items-center gap-3 text-xs text-foreground-400 mb-3 flex-wrap">
                  <span className="px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap">
                    {article.categoryName}
                  </span>
                  <span>{article.publishDate}</span>
                  <span>·</span>
                  <span>{article.readTime}</span>
                </div>
                <h3 className="font-heading font-semibold text-foreground-950 mb-2 leading-snug line-clamp-2"
                  style={{ fontSize: index === 0 ? '1.25rem' : '1.05rem' }}>
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-2 mt-3 text-xs text-foreground-400">
                  <i className="ri-user-line" />
                  <span>{article.author}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}